import React from 'react';

import Field from 'ui/Field';
import { HStack, VStack } from 'ui/Layout';
import { Text } from 'ui/Typography';

import {
  fontFamilyOptions,
  labelPositionsOptions,
  numberOfDecimalsOptions,
  secondLabelLineValueOptions,
  thirdLabelLineValueOptions,
} from '../../../constants';
import { useSankeyFormContext } from '../../../contexts/sankeyFormContext';
import { FormSelect, FormSlider, FormTextInput } from '../../SankeyForm';
import MenuSection from '../MenuSection';

const LabelsContent: React.FC = () => {
  const { form } = useSankeyFormContext();
  const showComparisonLine = form.watch('show_comparison_line');

  return (
    <VStack alignItems="stretch" gap={3}>
      <Field label="Font" fontSize="xs">
        <FormSelect field="font_family" options={fontFamilyOptions} size="sm" />
      </Field>
      <MenuSection label="General">
        <FormSlider label="Size" field="font_size" />
        <Field label="Position" fontSize="xs">
          <FormSelect
            field="label_pos"
            options={labelPositionsOptions}
            size="sm"
          />
        </Field>
        <Field label="Decimal places" fontSize="xs">
          <FormSelect
            field="nr_of_decimals"
            options={numberOfDecimalsOptions}
            size="sm"
          />
        </Field>
      </MenuSection>
      <MenuSection label="Amount (2nd line)">
        <HStack>
          <FormTextInput label="Prefix" field="unit_prefix" size="sm" />
          <Field label="Value" minW="180px" fontSize="xs">
            <FormSelect
              field="second_label_line_value_type"
              options={secondLabelLineValueOptions}
              size="sm"
            />
          </Field>
          <FormTextInput label="Suffix" field="unit_suffix" size="sm" />
        </HStack>
      </MenuSection>
      <MenuSection label="Comparison (3rd line)">
        {showComparisonLine ? (
          <HStack>
            <FormTextInput
              label="Prefix"
              field="comparison_line_prefix"
              size="sm"
            />
            <Field label="Value" minW="180px" fontSize="xs">
              <FormSelect
                field="comparison_line_value_type"
                options={thirdLabelLineValueOptions}
                size="sm"
              />
            </Field>
            <FormTextInput
              label="Suffix"
              field="comparison_line_suffix"
              size="sm"
            />
          </HStack>
        ) : (
          <Text color="gray.500" fontSize="sm">
            Not shown
          </Text>
        )}
      </MenuSection>
    </VStack>
  );
};

export default LabelsContent;
